import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { Constants } from 'src/app/shared/api/constants';
import { GeoLocationService } from 'src/app/shared/services/geo-location.service';
import { MapsLoaderService } from 'src/app/shared/services/maps-loader.service';

@Component({
  selector: 'app-map-search',
  templateUrl: './map-search.component.html',
  styleUrls: ['./map-search.component.scss']
})
export class MapSearchComponent implements OnInit, AfterViewInit {
  @ViewChild('address_search', { static: false }) addressSearchInput: ElementRef<HTMLInputElement>;
  @Input() map: google.maps.Map;
  @Output() autocompleteResult = new EventEmitter<google.maps.places.PlaceResult>();

  private autocomplete: google.maps.places.Autocomplete = null;
  private autoCompletInitialized = false;
  private placesAutocompleteListener: google.maps.MapsEventListener = null;

  public isMobile = false;
  public expanded = false;

  constructor(
    private geoLocationService: GeoLocationService,
    private readonly mapsLoaderService: MapsLoaderService,
    private changeDetector: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < Constants.xs;
  }

  ngAfterViewInit() {
    if (!this.autoCompletInitialized) {
      this.initAutoComplete();
      this.autoCompletInitialized = true;
    }
  }

  private initAutoComplete(): void {
    const input = this.addressSearchInput.nativeElement;
    this.autocomplete = new google.maps.places.Autocomplete(input, {});
    this.placesAutocompleteListener = this.autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          this.autocompleteResult.emit(null);
        } else {
          this.autocompleteResult.emit(place);
        }
      });
    });
  }

  public onSearchIconClick(_event) {
    this.expanded = true;
    this.changeDetector.detectChanges();
    this.focusInputField();
  }

  private focusInputField(): void {
    this.addressSearchInput.nativeElement.focus();
  }
}
